import React, { useEffect } from "react";
import Search from "./Search";
import Questions from "./Questions";

import { fetchHelp, searchHelp } from "../../../states/actions/fetchHelp";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import MetaGenerator from "../../common/meta-generator";

const Help = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchHelp.content);
  const isLoading = useSelector((state) => state.fetchHelp.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  const { content, meta } = data;

  const handleSearch = (formData) => {
    dispatch(searchHelp(formData));
  };

  useEffect(() => {
    dispatch(fetchHelp());
  }, []);

  // useDocumentTitle(data.page_title);

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <MetaGenerator page_title={data?.page_title} meta_desc={meta} />
          <Search content={content} handleSearch={handleSearch} />
          <Questions />
        </>
      )}
    </>
  );
};

export default Help;
